import gql from 'graphql-tag';
const KEYBOARDING_VIDEO_FRAGMENT = gql `
  fragment KeyboardingVideoFragment on KeyboardingVideo {
    autoPlay
    type
    video
  }
`;
export default KEYBOARDING_VIDEO_FRAGMENT;
